/**
 * Boxes as printed on ICS 236-CG (Jan 2026), Tentative Release List.
 *
 * Box 5 is preprinted ("To: Demobilization Unit Leader") with nothing to fill,
 * so the card shows it as a read-only box rather than dropping it and leaving
 * a gap in the numbering.
 */
export const ICS236_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  date: '3. Date:',
  from: '4. From: (Section Chief or Command Staff Officer)',
  to: '5. To: Demobilization Unit Leader',
  surplusResources: '6. Resources surplus as of:',
  preparedBy: '7. Prepared by:',
} as const;

/** Box 5 has no blank; this is what the sheet prints in it. */
export const ICS236_TO_VALUE = 'Demobilization Unit Leader';

/** Box 6's sentence, which wraps the two blanks the card collects. */
export const ICS236_SURPLUS_SENTENCE =
  'The following resources are surplus as of the time and date below. At that time, these resources are available for release processing.';

/** Columns of the box 6 table. */
export const ICS236_RESOURCE_COLUMNS = [
  {
    key: 'name',
    label: 'Name of Individual, Crew, or Resource/Equipment in excess',
  },
  { key: 'position', label: 'Position on Incident' },
] as const;
